import { useScrollLock } from '@vueuse/core';
import { defineComponent, ref, computed } from 'vue-demi';
import { u as useElevation } from './useElevation-a50ec347.js';
import '@onereach/styles/tailwind.config';
import 'tailwindcss/resolveConfig';
import { s as script$1 } from './OrTeleport.vue3-8099178c.js';
import { resolveComponent, openBlock, createBlock, withCtx, createElementVNode, mergeProps, renderSlot } from 'vue';

const OverlayRoot = [
// Position
'fixed', 'inset-none',
// Layout
'flex', 'items-center', 'justify-center',
// Theme
'bg-overlay', 'dark:bg-overlay-dark'];

var script = defineComponent({
  name: 'OrOverlay',
  components: {
    OrTeleport: script$1
  },
  inheritAttrs: false,
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-overlay-v3', ...OverlayRoot]);
    // Effects
    // #region Elevation
    useElevation(root);
    // #endregion
    // #region Scroll Lock
    useScrollLock(document.body, true);
    // #endregion
    return {
      root,
      rootStyles
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrTeleport = resolveComponent("OrTeleport");
  return openBlock(), createBlock(_component_OrTeleport, {
    disabled: !_ctx.fullscreen
  }, {
    default: withCtx(() => [createElementVNode("div", mergeProps({
      ref: "root"
    }, _ctx.$attrs, {
      class: _ctx.rootStyles
    }), [renderSlot(_ctx.$slots, "default")], 16 /* FULL_PROPS */)]),

    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled"]);
}

script.render = render;
script.__file = "src/components/or-overlay-v3/OrOverlay.vue";

export { script as s };
